<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ 'screening.monitoring_remove_person_modal.title' | translate }}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close modal" (click)="cancelAndClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<ng-container>
  @if (!isLoading) {
    <div class="modal-body">
      <div class="form-group" [class.form-error-highlight]="commentControl.invalid">
        <label class="label" for="monitoring_comment">{{
          'screening.set_on_monitoring_modal.form.monitoring_comment' | translate
        }}</label>
        <textarea class="form-control" id="monitoring_comment" [formControl]="commentControl"></textarea>
      </div>
    </div>
  } @else {
    <div class="modal-body">
      <nk-spinner display="inline-block"></nk-spinner>
    </div>
  }
  <div class="modal-footer">
    <button nkButton color="primary" [ghost]="true" (click)="cancelAndClose()">
      {{ 'common.cancel' | translate }}
    </button>
    <button class="btn btn-danger" [disabled]="commentControl.invalid || isLoading" (click)="removeAndClose()">
      {{ 'common.ok' | translate }} <nk-spinner display="inline" [hidden]="!isLoading"></nk-spinner>
    </button>
  </div>
</ng-container>
